import { ArrowRight, Filter, Search, Calendar, List, Grid, Plus, X } from "react-feather";
import { FormControl, InputLabel, Select, MenuItem, TextField, IconButton, Button, Checkbox } from "@mui/material";
import { DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";
import styles from "../prospectListView.module.css";
import NumberFormat from "react-number-format";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import React from "react";

const CreditScoreField = React.forwardRef((props, ref) => {
  return (<NumberFormat
    customInput={TextField}
    prefix=""
    displayType="input"
    format={"###"}
    {...props}
  />);
});

const MoneyField = React.forwardRef((props, ref) => {
  return (<NumberFormat
    customInput={TextField}
    prefix=""
    displayType="input"
    type="text"
    thousandSeparator={true}
    allowNegative={false}
    decimalScale={0}
    {...props}
  />);
});

const schema1 = yup.object().shape({
  min: yup.string().required("This field is Required"),
  max: yup.string().required("This field is Required"),
});

const schema2 = yup.object().shape({
  min: yup.string().required("This field is Required"),
  max: yup.string().required("This field is Required"),
});

const ListFilters = ({ setFilterData, setFilterOpen, filterOpen, filterData, propertyList, handleView, setCurrentFilterValue, setOpenAddProspectModal, setAddFormStep, isAuthenticated, setCreditFilterOpen, setAddCustomCredit, onSubmitCreditFiler, addCustomCredit, setCreditFilterDefaultOpen, creditFilterOpen, user, setSalaryFilterOpen, salaryFilterOpen, setAddCustomSalary, onSubmitSalaryFiler, addCustomSalary, setSalaryFilterDefaultOpen, setSearchKey, salaryFilterList, creditFilterList, delCustomFilter }) => {

  const { handleSubmit: handleSubmit1, control: control1 } = useForm({
    resolver: yupResolver(schema1),
  });

  const { handleSubmit: handleSubmit2, control: control2 } = useForm({
    resolver: yupResolver(schema2),
  });

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" onChange={(e) => {
          const handler = setTimeout(() => {
            setSearchKey(e.target.value);
            setCurrentFilterValue("search");
          }, 1000);

          return () => {
            clearTimeout(handler);
          }
        }} />
      </div>
      <div className={`${styles.ListGridBUCard} ${styles.Top}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU}`} onClick={() => handleView("list")}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>

      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:create") > -1 && (<button className={`${styles.AddNoteBu} ${styles.Top}`} onClick={(e) => { setOpenAddProspectModal(true); setAddFormStep(1); }}>
        <Plus /> <span>Prospect</span>
      </button>)}
    </div>

    <div className={`${styles.FilterSec}`}>
      <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters{" "}
          <span onClick={(e) => setFilterOpen(false)}>
            <ArrowRight />
          </span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Property</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Property"
              value={filterData?.property}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, property: e.target.value };
                });
                setCurrentFilterValue("property");
              }}
            >
              {propertyList?.map((i) => {
                return (<MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>);
              })}
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Prospects</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Prospects"
              value={filterData.prospect || []}
              onChange={(e) => {
                const value = e.target.value;

                if (value.includes("all")) {
                  const isAllSelected = filterData.prospect.length === 7;
                  if (isAllSelected) {
                    setFilterData(prev => {
                      return { ...prev, prospect: [] };
                    });
                  } else {
                    setFilterData(prev => {
                      return { ...prev, prospect: ['applied', 'not_applied', 'screened', 'approved', 'declined', 'airbnb', 'archived'] };
                    });
                  }
                  return;
                }

                setFilterData(prev => {
                  return { ...prev, prospect: value };
                });

                setCurrentFilterValue("prospect");
              }}
              multiple
              renderValue={(e) => {
                if (e.length === 0)
                  return 'None Selected';
                else if (e.length === 7)
                  return 'All selected';
                else
                  return e.length + ' selected'
              }}
            >
              <MenuItem value="all">
                <Checkbox
                  indeterminate={!(filterData.prospect.indexOf("applied") > -1 && filterData.prospect.indexOf("not_applied") > -1 && filterData.prospect.indexOf("screened") > -1 && filterData.prospect.indexOf("approved") > -1 && filterData.prospect.indexOf("declined") > -1 && filterData.prospect.indexOf("airbnb") > -1 && filterData.prospect.indexOf("archived") > -1) && (filterData.prospect.indexOf("applied") > -1 || filterData.prospect.indexOf("not_applied") > -1 || filterData.prospect.indexOf("screened") > -1 || filterData.prospect.indexOf("approved") > -1 || filterData.prospect.indexOf("declined") > -1 || filterData.prospect.indexOf("airbnb") > -1 || filterData.prospect.indexOf("archived") > -1)}
                  checked={filterData.prospect.indexOf("applied") > -1 && filterData.prospect.indexOf("not_applied") > -1 && filterData.prospect.indexOf("screened") > -1 && filterData.prospect.indexOf("approved") > -1 && filterData.prospect.indexOf("declined") > -1 && filterData.prospect.indexOf("airbnb") > -1 && filterData.prospect.indexOf("archived") > -1}
                />
                All Prospects
              </MenuItem>
              <MenuItem value="applied">
                <Checkbox checked={filterData.prospect.indexOf("applied") > -1} />
                Applied
              </MenuItem>
              <MenuItem value="not_applied">
                <Checkbox checked={filterData.prospect.indexOf("not_applied") > -1} />
                Not Applied
              </MenuItem>
              <MenuItem value="screened">
                <Checkbox checked={filterData.prospect.indexOf("screened") > -1} />
                Screened
              </MenuItem>
              <MenuItem value="approved">
                <Checkbox checked={filterData.prospect.indexOf("approved") > -1} />
                Approved
              </MenuItem>
              <MenuItem value="declined">
                <Checkbox checked={filterData.prospect.indexOf("declined") > -1} />
                Declined
              </MenuItem>
              <MenuItem value="airbnb">
                <Checkbox checked={filterData.prospect.indexOf("airbnb") > -1} />
                Airbnb Guest
              </MenuItem>
              <MenuItem value="archived">
                <Checkbox checked={filterData.prospect.indexOf("archived") > -1} />
                Archived
              </MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.FilterCard}`}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
            <DateRangePicker
              format={"MM/dd/yy"}
              placeholder={"Filter by date"}
              placement={"bottomEnd"}
              caretAs={Calendar}
              showOneCalendar
              onChange={(date) => {
                setFilterData((prev) => {
                  return { ...prev, submitted_at: date };
                });
                setCurrentFilterValue("submitted_at");
              }}
            />
          </div>
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width150} CusSelectFilter Filter CloseFilter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Filter by Credit</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Filter by Credit"
              value={filterData?.credit || ""}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, credit: e.target.value };
                });
                setCurrentFilterValue("credit");
                setCreditFilterDefaultOpen(true);
              }}
              endAdornment={filterData?.credit && (<IconButton
                size="small"
                onClick={(e) => {
                  setFilterData((prev) => {
                    return { ...prev, credit: "" };
                  });
                }}
              >
                <X />
              </IconButton>)}
              open={creditFilterOpen}
              onClose={(e) => { setCreditFilterOpen(false); }}
              onOpen={(e) => setCreditFilterOpen(true)}
              renderValue={(selected) => {
                if (!selected) return "";
                if (selected === "all") return "All Credit Scores";
                if (selected === "custom") return "Custom";
                if (selected === "0,649") return "Below 650";
                if (selected === "650,0") return "650 & Above";

                const item = creditFilterList?.find(i => i.value === selected);
                return item?.label || selected;
              }}
            >
              <MenuItem value="all">All Credit Scores</MenuItem>
              <MenuItem value={"0,649"}>Below 650</MenuItem>
              <MenuItem value={"650,0"}>650 & Above</MenuItem>
              {creditFilterList?.map(i => {
                return <MenuItem value={i?.value}>
                  {i?.label}
                  {i?.is_custom === 1 && <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      delCustomFilter(i?.value, 'credit');
                    }}
                  >
                    <X fontSize="small" />
                  </IconButton>}
                </MenuItem>
              })}
              <MenuItem value="custom" className={`${styles.customcredit}`} onClick={(e) => { setAddCustomCredit(true); }}>{"Custom"}</MenuItem>
              {addCustomCredit && (<div className={`${styles.CustomFilterSec}`}>
                <form onSubmit={handleSubmit1(onSubmitCreditFiler)}>
                  <div className={`${styles.CustomFilterSecRow}`}>
                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                      <Controller
                        name={`min`}
                        control={control1}
                        render={(field) => (<CreditScoreField
                          {...field}
                          id="outlined-basic"
                          label="Min Score"
                          variant="outlined"
                          onClick={(e) => e.stopPropagation()}
                          onKeyDown={(e) => e.stopPropagation()}
                          onChange={(e) => {
                            e.stopPropagation();
                            field.onChange(e);
                          }}
                        />)}
                      />
                    </div>
                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                      <Controller
                        name={`max`}
                        control={control1}
                        render={(field) => (<CreditScoreField
                          {...field}
                          id="outlined-basic"
                          label="Max Score"
                          variant="outlined"
                          onClick={(e) => e.stopPropagation()}
                          onKeyDown={(e) => e.stopPropagation()}
                          onChange={(e) => {
                            e.stopPropagation();
                            field.onChange(e);
                          }}
                        />)}
                      />
                    </div>
                    <div className={`${styles.CustomFiletrBUsec}`}>
                      <Button onClick={(e) => { setAddCustomCredit(false); setFilterData((prev) => { return { ...prev, credit: "" }; }); setCreditFilterOpen(false); }} className={`${styles.CancelPopupBU}`}>Cancel</Button>
                      <Button className={`${styles.SubmitPopupBU}`} type="submit">Apply</Button>
                    </div>
                  </div>
                </form>
              </div>)}
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width180} CusSelectFilter Filter CloseFilter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Filter by Salary</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Filter by Salary"
              value={filterData?.income || ""}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, income: e.target.value };
                });
                setCurrentFilterValue("income");
                setSalaryFilterDefaultOpen(true);
              }}
              endAdornment={filterData?.income && (<IconButton
                size="small"
                onClick={(e) => {
                  setFilterData((prev) => {
                    return { ...prev, income: "" };
                  });
                }}
              >
                <X />
              </IconButton>)}
              open={salaryFilterOpen}
              onClose={(e) => { setSalaryFilterOpen(false); }}
              onOpen={(e) => setSalaryFilterOpen(true)}
              renderValue={(selected) => {
                if (!selected) return "";
                if (selected === "all") return "All Salary";
                if (selected === "custom") return "Custom";
                if (selected === "0,20000") return "< $20,000";
                if (selected === "20000,40000") return "$20,000 - $40,000";
                if (selected === "40000,60000") return "$40,000 - $60,000";
                if (selected === "60000,80000") return "$60,000 - $80,000";
                if (selected === "80000,0") return "> $80,000";

                const item = salaryFilterList?.find(i => i.value === selected);
                return item?.label || selected;
              }}
            >
              <MenuItem value="all">All Salary</MenuItem>
              <MenuItem value="0,20000">&lt; $20,000</MenuItem>
              <MenuItem value="20000,40000">$20,000 - $40,000</MenuItem>
              <MenuItem value="40000,60000">$40,000 - $60,000</MenuItem>
              <MenuItem value="60000,80000">$60,000 - $80,000</MenuItem>
              <MenuItem value="80000,0">&gt; $80,000</MenuItem>
              {salaryFilterList?.map(i => {
                return <MenuItem value={i?.value}>
                  {i?.label}
                  {i?.is_custom === 1 && <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      delCustomFilter(i?.value, 'salary');
                    }}
                  >
                    <X fontSize="small" />
                  </IconButton>}
                </MenuItem>
              })}
              <MenuItem value="custom" className={`${styles.customcredit}`} onClick={(e) => { setAddCustomSalary(true); }}>{"Custom"}</MenuItem>
              {addCustomSalary && (<div className={`${styles.CustomFilterSec}`}>
                <form onSubmit={handleSubmit2(onSubmitSalaryFiler)}>
                  <div className={`${styles.CustomFilterSecRow}`}>
                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                      <Controller
                        name={`min`}
                        control={control2}
                        render={(field) => (<MoneyField
                          {...field}
                          id="outlined-basic"
                          label="Min Salary"
                          variant="outlined"
                          onClick={(e) => e.stopPropagation()}
                          onKeyDown={(e) => e.stopPropagation()}
                          onChange={(e) => {
                            e.stopPropagation();
                            field.onChange(e);
                          }}
                        />)}
                      />
                    </div>
                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                      <Controller
                        name={`max`}
                        control={control2}
                        render={(field) => (<MoneyField
                          {...field}
                          id="outlined-basic"
                          label="Max Salary"
                          variant="outlined"
                          onClick={(e) => e.stopPropagation()}
                          onKeyDown={(e) => e.stopPropagation()}
                          onChange={(e) => {
                            e.stopPropagation();
                            field.onChange(e);
                          }}
                        />)}
                      />
                    </div>
                    <div className={`${styles.CustomFiletrBUsec}`}>
                      <Button onClick={(e) => { setAddCustomSalary(false); setFilterData((prev) => { return { ...prev, income: "" }; }); setSalaryFilterOpen(false); }} className={`${styles.CancelPopupBU}`}>Cancel</Button>
                      <Button className={`${styles.SubmitPopupBU}`} type="submit">Apply</Button>
                    </div>
                  </div>
                </form>
              </div>)}
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Follow-up Notes</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Follow-up Notes"
              value={filterData?.notes}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, notes: e.target.value };
                });
                setCurrentFilterValue("notes");
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="notes">Notes</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
      <div className={`${styles.ListGridBUCard} ${styles.Bottom}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU}`} onClick={() => handleView("list")}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>

      <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}><Filter /></Link>

      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:create") > -1 && (<button className={`${styles.AddNoteBu} ${styles.Bottom}`} onClick={(e) => { setOpenAddProspectModal(true); setAddFormStep(1); }}>
        <Plus /> <span>Prospect</span>
      </button>)}
    </div>
  </div>);
}

export default ListFilters;